import type React from 'react'
import { useTranslation } from 'react-i18next'

import { SkeletonBlock } from '@/components/framework'

export const ShiftTimelineSkeleton: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="space-y-4" role="status" aria-label={t('shiftTimeline.loadingTimeline')}>
      <div
        className="flex flex-wrap items-center gap-3 border-b border-gray-200 bg-gray-50 p-4"
        aria-hidden="true"
      >
        <SkeletonBlock className="h-10 w-48" />
        <SkeletonBlock className="h-10 w-64" />
        <SkeletonBlock className="h-10 min-w-64 flex-1" />
        <SkeletonBlock className="h-10 w-24" />
        <SkeletonBlock className="h-10 w-24" />
      </div>
      <div className="space-y-3 p-4" aria-hidden="true">
        <SkeletonBlock className="h-6 w-64" />
        <SkeletonBlock className="h-105 w-full" />
      </div>
    </div>
  )
}
